export default __webpack_public_path__ + "static/media/5361@3x.4ff82040.png";